// App.js - WEB
import React, {lazy, Suspense, PureComponent} from 'react';
import {I18nManager, Platform} from 'react-native';
//import {ModalContainer} from "react-router-modal";
// import {connect} from "react-redux";
// import store from "../../redux/store/index137";
// import {
//     NavigationContainer,
//     DarkTheme as NavigationDarkTheme,
// } from '@react-navigation/native';
// import {createDrawerNavigator} from '@react-navigation/drawer';
// import {createStackNavigator} from '@react-navigation/stack';
// import {createBottomTabNavigator} from '@react-navigation/bottom-tabs';
//
// import {enableScreens} from 'react-native-screens';
//
// import AsyncStorage from '@react-native-community/async-storage';
//
// import {typeExport} from "../../redux/store/type";
// import {navigationRef} from "../../redux/NavigationService";
// import {AsyngStorageClass} from "../../tools/AsyngStorageClass";
// import {Tools} from "../../tools/Tools";
// import NetInfo from "@react-native-community/netinfo";

/*

import ListNewsScreen from "../../screens/137/main/news/action/ActionListNewsScreen";
import EnterCodeScreen from "../../screens/137/login/code/action/ActionEnterCodeScreen";
import InformationScreen from "../../screens/137/login/informaion/action/ActionInformationScreen";
import LoginEnterPhoneScreen from "../../screens/137/login/loginUsername/action/ActionLoginEnterPhoneScreen";
import LoginScreen from "../../screens/137/login/action/ActionLoginScreen";
import LoginEnterPhoneCodeScreen from "../../screens/137/login/loginMobile/action/ActionLoginEnterPhoneCodeScreen";
import MainScreen from "../../screens/137/main/MainScreen";
import MenuDrawer from "../../drawer/right/MenuDrawer";
import SatiaScreen from "../../screens/common/contactUs/SatiaScreen";
import ShowMap from "../../screens/common/map/ShowMap";
import WebViewScreen from "../../screens/common/webview/WebViewScreen";
import ApplyScreen from "../../screens/137/main/applay/action/ActionApplyScreen";
import DetailsScreen from "../../screens/137/main/details/action/ActionDetailsScreen";
import CategoryScreen from "../../screens/137/main/category/action/ActionCategoryScreen";
import AdvancedSearchScreen from "../../screens/137/main/pageGraveyard/AdvancedSearchScreen";
import DetailsDeadScreen from "../../screens/137/main/pageGraveyard/DetailsDeadScreen";
import ListDeadScreen from "../../screens/137/main/pageGraveyard/action/ActionListDeadScreen";
import ListMyApplyScreen from "../../screens/137/main/applay/action/ActionListMyApplysScreen";
import ListMyRegisterComplaintsScreen from "../../screens/137/main/applay/action/ActionListMyRegisterComplaintsScreen";
import SubmitRequestScreen22 from "../../screens/137/main/applay/submitRequest/action/ActionSubmitRequestScreen22";
import DetailsRequestScreen from "../../screens/137/main/applay/action/ActionDetailsRequestScreen";
import ProfileScreen from "../../screens/137/main/profile/ProfileScreen";
import RegisterComplaintsScreen from "../../screens/137/main/applay/submitComplaint/action/ActionRegisterComplaintsScreen";
import DetailsRegisterComplaintsScreen from "../../screens/137/main/applay/DetailsRegisterComplaintsScreen";
import ChangePassScreen from "../../screens/137/login/changePass/action/ActionChangPssScreen";
import ChangeInformationScreen from "../../screens/137/login/changeInformatin/action/ActionChangeInformationScreen";
import ListMyApplyOperationScreen from "../../screens/137/main/applay/action/ActionListMyApplysOperationScreen";
import ListOperatorApplyScreen from "../../screens/137/main/applay/action/ActionListOperatorApplysScreen";
import DetailsOperatorApplyScreen from "../../screens/137/main/applay/action/ActionDetailsOperatorApplyScreen";
import SubmitSwitchingOperationScreen from "../../screens/137/main/applay/submitSwitch/action/ActionSubmitSwitchingOperationScreen";
import GalleryServiceOperationScreen from "../../screens/137/main/applay/action/ActionGalleryServiceOperationScreen";
import GalleryServiceScreen from "../../screens/137/main/applay/action/ActionGalleryServiceScreen";
import ShahrbanSatiaScreen from "../../screens/common/contactUs/ShahrbanSatiaScreen";
import DetailsGalleryServiceScreen from "../../screens/137/main/applay/DetailsGalleryServiceScreen";
import DetailsGalleryServiceOperationScreen from "../../screens/137/main/applay/DetailsGalleryServiceOperationScreen";
import ChatMessageScreen from "../../screens/common/chat/ChatMessageScreen";
import ListMessageChatScreen from "../../screens/common/chat/action/ActionListMessageChatScreen";
import ListUserChatScreen from "../../screens/common/chat/action/ActionListUserChatScreen";
import AboutUsScreen from "../../screens/common/contactUs/AboutUsScreen";
import PrivacyScreen from "../../screens/common/contactUs/PrivacyScreen";
import ListReport15RequestScreen from "../../screens/137/main/reports/action/ActionListReport15RequestScreen";
import ListReportStatusRequestScreen from "../../screens/137/main/reports/action/ActionListReportStatusRequestScreen";
import DetailsListTaskReportScreen from "../../screens/137/main/reports/DetailsListTaskReportScreen";
import ListReportTaskRequestScreen from "../../screens/137/main/reports/action/ActionListReportTaskRequestScreen";
import SubmitSendOperationScreen from "../../screens/137/main/applay/submitSend/action/ActionSubmitSendOperationScreen";
import MediaRecorderCapture from "../../customviews/record/video/MediaRecorderCapture";
import AClass from "../../screens/test/AClass";
import BClass from "../../screens/test/BClass";
import ExpertRegistrationMahaleMaScreen from "../../screens/137/main/reports/mahaleMa/action/ActionExpertRegistrationMahaleMaScreen";
import ListReportMahalehMaScreen from "../../screens/137/main/reports/mahaleMa/action/ActionListReportMahalehMaScreen";
import ListReportExitEnterMahalehMaScreen from "../../screens/137/main/reports/mahaleMa/action/ActionListReportExitEnterMahalehMaScreen";
import SettingMyStateScreen from "../../screens/137/main/myState/setting/SettingMyStateScreen";
import AddPatternMyStateScreen from "../../screens/137/main/myState/setting/AddPatternMyStateScreen";
import AccessReportMyStateScreen from "../../screens/137/main/myState/setting/AccessReportMyStateScreen";
import SettingReportMyStateScreen from "../../screens/137/main/myState/setting/SettingReportMyStateScreen";
import EditPatternShowMyStateScreen from "../../screens/137/main/myState/setting/EditPatternShowMyStateScreen";
import DashboardMyStateScreen from "../../screens/137/main/myState/setting/DashboardMyStateScreen";
import SecondScreen from "../../web/screens/SecondScreen";
*/
const possiblePaths = {
    SplashScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/splash/action/ActionSplashGetAllData')) : require('../../screens/137/splash/action/ActionSplashGetAllData').default,
    MainScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/MainScreen')) : require('../../screens/137/main/MainScreen').default,
    ListNewsScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/news/action/ActionListNewsScreen')) : require('../../screens/137/main/news/action/ActionListNewsScreen').default,
    EnterCodeScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/login/code/action/ActionEnterCodeScreen')) : require('../../screens/137/login/code/action/ActionEnterCodeScreen').default,
    InformationScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/login/informaion/action/ActionInformationScreen')) : require('../../screens/137/login/informaion/action/ActionInformationScreen').default,
    LoginEnterPhoneScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/login/loginUsername/action/ActionLoginEnterPhoneScreen')) : require('../../screens/137/login/loginUsername/action/ActionLoginEnterPhoneScreen').default,
    LoginScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/login/action/ActionLoginScreen')) : require('../../screens/137/login/action/ActionLoginScreen').default,
    LoginEnterPhoneCodeScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/login/loginMobile/action/ActionLoginEnterPhoneCodeScreen')) : require('../../screens/137/login/loginMobile/action/ActionLoginEnterPhoneCodeScreen').default,
    MenuDrawer: Platform.OS === 'web' ? lazy(() => import('../../drawer/right/MenuDrawer')) : require('../../drawer/right/MenuDrawer').default,
    SatiaScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/common/contactUs/SatiaScreen')) : require('../../screens/common/contactUs/SatiaScreen').default,
    ShowMap: Platform.OS === 'web' ? lazy(() => import('../../screens/common/map/ShowMap')) : require('../../screens/common/map/ShowMap').default,
    WebViewScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/common/webview/WebViewScreen')) : require('../../screens/common/webview/WebViewScreen').default,
    ApplyScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/applay/action/ActionApplyScreen')) : require('../../screens/137/main/applay/action/ActionApplyScreen').default,
    DetailsScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/details/action/ActionDetailsScreen')) : require('../../screens/137/main/details/action/ActionDetailsScreen').default,
    CategoryScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/category/action/ActionCategoryScreen')) : require('../../screens/137/main/category/action/ActionCategoryScreen').default,
    AdvancedSearchScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/pageGraveyard/AdvancedSearchScreen')) : require('../../screens/137/main/pageGraveyard/AdvancedSearchScreen').default,
    DetailsDeadScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/pageGraveyard/DetailsDeadScreen')) : require('../../screens/137/main/pageGraveyard/DetailsDeadScreen').default,
    ListDeadScreen: Platform.OS === 'web' ? lazy(() => import( '../../screens/137/main/pageGraveyard/action/ActionListDeadScreen')) : require('../../screens/137/main/pageGraveyard/action/ActionListDeadScreen').default,
    ListMyApplyScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/applay/action/ActionListMyApplysScreen')) : require('../../screens/137/main/applay/action/ActionListMyApplysScreen').default,
    ListMyRegisterComplaintsScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/applay/action/ActionListMyRegisterComplaintsScreen')) : require('../../screens/137/main/applay/action/ActionListMyRegisterComplaintsScreen').default,
    SubmitRequestScreen22: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/applay/submitRequest/action/ActionSubmitRequestScreen22')) : require('../../screens/137/main/applay/submitRequest/action/ActionSubmitRequestScreen22').default,
    DetailsRequestScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/applay/action/ActionDetailsRequestScreen')) : require('../../screens/137/main/applay/action/ActionDetailsRequestScreen').default,
    ProfileScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/profile/ProfileScreen')) : require('../../screens/137/main/profile/ProfileScreen').default,
    RegisterComplaintsScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/applay/submitComplaint/action/ActionRegisterComplaintsScreen')) : require('../../screens/137/main/applay/submitComplaint/action/ActionRegisterComplaintsScreen').default,
    DetailsRegisterComplaintsScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/applay/DetailsRegisterComplaintsScreen')) : require('../../screens/137/main/applay/DetailsRegisterComplaintsScreen').default,
    ChangePassScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/login/changePass/action/ActionChangPssScreen')) : require('../../screens/137/login/changePass/action/ActionChangPssScreen').default,
    ChangeInformationScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/login/changeInformatin/action/ActionChangeInformationScreen')) : require('../../screens/137/login/changeInformatin/action/ActionChangeInformationScreen').default,
    ListMyApplyOperationScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/applay/action/ActionListMyApplysOperationScreen')) : require('../../screens/137/main/applay/action/ActionListMyApplysOperationScreen').default,
    ListOperatorApplyScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/applay/action/ActionListOperatorApplysScreen')) : require('../../screens/137/main/applay/action/ActionListOperatorApplysScreen').default,
    DetailsOperatorApplyScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/applay/action/ActionDetailsOperatorApplyScreen')) : require('../../screens/137/main/applay/action/ActionDetailsOperatorApplyScreen').default,
    SubmitSwitchingOperationScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/applay/submitSwitch/action/ActionSubmitSwitchingOperationScreen')) : require('../../screens/137/main/applay/submitSwitch/action/ActionSubmitSwitchingOperationScreen').default,
    GalleryServiceOperationScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/applay/action/ActionGalleryServiceOperationScreen')) : require('../../screens/137/main/applay/action/ActionGalleryServiceOperationScreen').default,
    GalleryServiceScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/applay/action/ActionGalleryServiceScreen')) : require('../../screens/137/main/applay/action/ActionGalleryServiceScreen').default,
    ShahrbanSatiaScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/common/contactUs/ShahrbanSatiaScreen')) : require('../../screens/common/contactUs/ShahrbanSatiaScreen').default,
    DetailsGalleryServiceScreen: Platform.OS === 'web' ? lazy(() => import( '../../screens/137/main/applay/DetailsGalleryServiceScreen')) : require('../../screens/137/main/applay/DetailsGalleryServiceScreen').default,
    DetailsGalleryServiceOperationScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/applay/DetailsGalleryServiceOperationScreen')) : require('../../screens/137/main/applay/DetailsGalleryServiceOperationScreen').default,
    ChatMessageScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/common/chat/ChatMessageScreen')) : require('../../screens/common/chat/ChatMessageScreen').default,
    ListMessageChatScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/common/chat/action/ActionListMessageChatScreen')) : require('../../screens/common/chat/action/ActionListMessageChatScreen').default,
    ListUserChatScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/common/chat/action/ActionListUserChatScreen')) : require('../../screens/common/chat/action/ActionListUserChatScreen').default,
    AboutUsScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/common/contactUs/AboutUsScreen')) : require('../../screens/common/contactUs/AboutUsScreen').default,
    PrivacyScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/common/contactUs/PrivacyScreen')) : require('../../screens/common/contactUs/PrivacyScreen').default,
    ListReportArrearsScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/reports/action/ActionListReportArrearsScreen')) : require('../../screens/137/main/reports/action/ActionListReportArrearsScreen').default,
    ListReport15RequestScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/reports/action/ActionListReport15RequestScreen')) : require('../../screens/137/main/reports/action/ActionListReport15RequestScreen').default,
    ListReport15RequestScreen2: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/reports/action/ActionListReport15RequestScreen2')) : require('../../screens/137/main/reports/action/ActionListReport15RequestScreen2').default,
    ListReportStatusRequestScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/reports/action/ActionListReportStatusRequestScreen')) : require('../../screens/137/main/reports/action/ActionListReportStatusRequestScreen').default,
    ListReportStatusRequestScreen2: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/reports/action/ActionListReportStatusRequestScreen2')) : require('../../screens/137/main/reports/action/ActionListReportStatusRequestScreen2').default,
    DetailsListTaskReportScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/reports/DetailsListTaskReportScreen')) : require('../../screens/137/main/reports/DetailsListTaskReportScreen').default,
    ListReportTaskRequestScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/reports/action/ActionListReportTaskRequestScreen')) : require('../../screens/137/main/reports/action/ActionListReportTaskRequestScreen').default,
    SubmitSendOperationScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/applay/submitSend/action/ActionSubmitSendOperationScreen')) : require('../../screens/137/main/applay/submitSend/action/ActionSubmitSendOperationScreen').default,
    MediaRecorderCapture: Platform.OS === 'web' ? lazy(() => import('../../customviews/record/video/MediaRecorderCapture')) : require('../../customviews/record/video/MediaRecorderCapture').default,
    AClass: Platform.OS === 'web' ? lazy(() => import('../../screens/test/AClass')) : require('../../screens/test/AClass').default,
    BClass: Platform.OS === 'web' ? lazy(() => import('../../screens/test/BClass')) : require('../../screens/test/BClass').default,
    ExpertRegistrationMahaleMaScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/reports/mahaleMa/action/ActionExpertRegistrationMahaleMaScreen')) : require('../../screens/137/main/reports/mahaleMa/action/ActionExpertRegistrationMahaleMaScreen').default,
    ListReportMahalehMaScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/reports/mahaleMa/action/ActionExpertRegistrationMahaleMaScreen')) : require('../../screens/137/main/reports/mahaleMa/action/ActionExpertRegistrationMahaleMaScreen').default,
    ListReportExitEnterMahalehMaScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/reports/mahaleMa/action/ActionListReportExitEnterMahalehMaScreen')) : require('../../screens/137/main/reports/mahaleMa/action/ActionListReportExitEnterMahalehMaScreen').default,

    SecondScreen: Platform.OS === 'web' ? lazy(() => import('../../web/screens/SecondScreen')) : require('../../web/screens/SecondScreen').default,
    HomeScreen: Platform.OS === 'web' ? lazy(() => import('../../web/screens/HomeScreen')) : require('../../web/screens/HomeScreen').default,

    SettingMyStateScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/myState/setting/SettingMyStateScreen')) : require('../../screens/137/main/myState/setting/SettingMyStateScreen').default,
    AddPatternMyStateScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/myState/setting/AddPatternMyStateScreen')) : require('../../screens/137/main/myState/setting/AddPatternMyStateScreen').default,
    AccessReportMyStateScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/myState/setting/AccessReportMyStateScreen')) : require('../../screens/137/main/myState/setting/AccessReportMyStateScreen').default,
    SettingReportMyStateScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/myState/setting/SettingReportMyStateScreen')) : require('../../screens/137/main/myState/setting/SettingReportMyStateScreen').default,
    EditPatternShowMyStateScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/myState/setting/EditPatternShowMyStateScreen')) : require('../../screens/137/main/myState/setting/EditPatternShowMyStateScreen').default,
    UnitsMyStateScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/myState/setting/UnitsMyStateScreen')) : require('../../screens/137/main/myState/setting/UnitsMyStateScreen').default,
    DashboardMyStateScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/myState/setting/DashboardMyStateScreen')) : require('../../screens/137/main/myState/setting/DashboardMyStateScreen').default,
    ChartMyStateScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/myState/setting/ChartMyStateScreen')) : require('../../screens/137/main/myState/setting/ChartMyStateScreen').default,
    ListCityScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/common/selectCity/ListCityScreen')) : require('../../screens/common/selectCity/ListCityScreen').default,
    ApplyParentScreen: Platform.OS === 'web' ? lazy(() => import('../../screens/137/main/applay/ApplyParentScreen')) : require('../../screens/137/main/applay/ApplyParentScreen').default,
   // PermissionsPage: Platform.OS === 'web' ? null : require('../../screens/common/camera/PermissionsPage').PermissionsPage,
  //  CameraPage: Platform.OS === 'web' ? null : require('../../screens/common/camera/CameraPage').CameraPage,
    //MediaPage: Platform.OS === 'web' ? null : require('../../screens/common/camera/MediaPage').MediaPage,
    CameraTestRecord: Platform.OS === 'web' ? null : require('../../screens/common/camera/CameraTestRecord').CameraTestRecord,

    //modules_customize
    //  store: Platform.OS === "web" ? lazy(() => import("../../redux/store/index")) : require("../../redux/store/index").default,
    // Tools: Platform.OS === "web" ? lazy(() => import("../../tools/Tools")) : require("../../tools/Tools"),
    // AsyngStorageClass: Platform.OS === "web" ? lazy(() => import("../../tools/AsyngStorageClass")) : require("../../tools/AsyngStorageClass"),
    // typeExport: Platform.OS === "web" ? lazy(() => import("../../redux/store/type")) : require("../../redux/store/type"),
    //NavigationService: Platform.OS === "web" ? lazy(() => import("../../redux/NavigationService")) : require("../../redux/NavigationService"),

    //modules
    //connect: Platform.OS === "web" ? lazy(() => import("react-redux")) : require("react-redux"),
    // react_navigation: Platform.OS === "web" ? lazy(() => import('@react-navigation/native')) : require('@react-navigation/native'),
    // drawer: Platform.OS === "web" ? lazy(() => import('@react-navigation/drawer')) : require('@react-navigation/drawer'),
    //  stack: Platform.OS === "web" ? lazy(() => import('@react-navigation/stack')) : require('@react-navigation/stack'),
    // bottom_tabs: Platform.OS === "web" ? lazy(() => import('@react-navigation/bottom-tabs')) : require('@react-navigation/bottom-tabs'),
    // enableScreens: Platform.OS === "web" ? lazy(() => import('react-native-screens')) : require('react-native-screens'),
    //  AsyncStorage: Platform.OS === "web" ? lazy(() => import('@react-native-community/async-storage')) : require('@react-native-community/async-storage'),
    // NetInfo: Platform.OS === "web" ? lazy(() => import("@react-native-community/netinfo")) : require("@react-native-community/netinfo"),
};
//const {connect} = getNameComponent('connect');
//console.log("@@@@@@", getNameComponent('react_navigation'))
//const {NavigationContainer, DarkTheme} = getNameComponent('react_navigation');
//const {createDrawerNavigator} = getNameComponent('drawer');
//const {createStackNavigator} = getNameComponent('stack');
//const {createBottomTabNavigator} = getNameComponent('bottom_tabs');
//const {enableScreens} = getNameComponent('enableScreens');
//const AsyncStorage = getNameComponent('AsyncStorage');
//const NetInfo = getNameComponent('NetInfo');

//const store = getNameComponent('store');
//const {typeExport} = getNameComponent('typeExport');
//const {navigationRef} = getNameComponent('NavigationService');
//const {AsyngStorageClass} = getNameComponent('AsyngStorageClass');
//const {Tools} = getNameComponent('Tools');


import {connect} from 'react-redux';
import store from '../../redux/store/index';
import {
    NavigationContainer,
    DarkTheme,
} from '@react-navigation/native';
import {createDrawerNavigator} from '@react-navigation/drawer';
import {createStackNavigator} from '@react-navigation/stack';
import {createBottomTabNavigator} from '@react-navigation/bottom-tabs';
import {enableScreens} from 'react-native-screens';
import AsyncStorage from '@react-native-community/async-storage';
import {typeExport} from '../../redux/store/type';
import {navigationRef} from '../../redux/NavigationService';
import {AsyngStorageClass} from '../../tools/AsyngStorageClass';
import {Tools} from '../../tools/Tools';
import NetInfo from '@react-native-community/netinfo';

//const ListNewsScreen = lazy(() => import( "../../screens/137/main/news/action/ActionListNewsScreen"));
//const EnterCodeScreen = lazy(() => import( "../../screens/137/login/code/action/ActionEnterCodeScreen"));
//const InformationScreen = lazy(() => import( "../../screens/137/login/informaion/action/ActionInformationScreen"));
//const LoginEnterPhoneScreen = lazy(() => import( "../../screens/137/login/loginUsername/action/ActionLoginEnterPhoneScreen"));
//const LoginScreen = lazy(() => import( "../../screens/137/login/action/ActionLoginScreen"));
//const LoginEnterPhoneCodeScreen = lazy(() => import( "../../screens/137/login/loginMobile/action/ActionLoginEnterPhoneCodeScreen"));
//const MainScreen = lazy(() => import( "../../screens/137/main/MainScreen"));
//const MenuDrawer = lazy(() => import( "../../drawer/right/MenuDrawer"));
//const SatiaScreen = lazy(() => import( "../../screens/common/contactUs/SatiaScreen"));
//const ShowMap = lazy(() => import( "../../screens/common/map/ShowMap"));
//const WebViewScreen = lazy(() => import( "../../screens/common/webview/WebViewScreen"));
//const ApplyScreen = lazy(() => import( "../../screens/137/main/applay/action/ActionApplyScreen"));
//const DetailsScreen = lazy(() => import( "../../screens/137/main/details/action/ActionDetailsScreen"));
//const CategoryScreen = lazy(() => import( "../../screens/137/main/category/action/ActionCategoryScreen"));
//const AdvancedSearchScreen = lazy(() => import( "../../screens/137/main/pageGraveyard/AdvancedSearchScreen"));
//const DetailsDeadScreen = lazy(() => import( "../../screens/137/main/pageGraveyard/DetailsDeadScreen"));
//const ListDeadScreen = lazy(() => import( "../../screens/137/main/pageGraveyard/action/ActionListDeadScreen"));
//const ListMyApplyScreen = lazy(() => import( "../../screens/137/main/applay/action/ActionListMyApplysScreen"));
//const ListMyRegisterComplaintsScreen = lazy(() => import( "../../screens/137/main/applay/action/ActionListMyRegisterComplaintsScreen"));
//const SubmitRequestScreen22 = lazy(() => import( "../../screens/137/main/applay/submitRequest/action/ActionSubmitRequestScreen22"));
//const DetailsRequestScreen = lazy(() => import( "../../screens/137/main/applay/action/ActionDetailsRequestScreen"));
//const ProfileScreen = lazy(() => import( "../../screens/137/main/profile/ProfileScreen"));
//const RegisterComplaintsScreen = lazy(() => import( "../../screens/137/main/applay/submitComplaint/action/ActionRegisterComplaintsScreen"));
//const DetailsRegisterComplaintsScreen = lazy(() => import( "../../screens/137/main/applay/DetailsRegisterComplaintsScreen"));
//const ChangePassScreen = lazy(() => import( "../../screens/137/login/changePass/action/ActionChangPssScreen"));
//const ChangeInformationScreen = lazy(() => import( "../../screens/137/login/changeInformatin/action/ActionChangeInformationScreen"));
//const ListMyApplyOperationScreen = lazy(() => import( "../../screens/137/main/applay/action/ActionListMyApplysOperationScreen"));
//const ListOperatorApplyScreen = lazy(() => import( "../../screens/137/main/applay/action/ActionListOperatorApplysScreen"));
//const DetailsOperatorApplyScreen = lazy(() => import( "../../screens/137/main/applay/action/ActionDetailsOperatorApplyScreen"));
//const SubmitSwitchingOperationScreen = lazy(() => import( "../../screens/137/main/applay/submitSwitch/action/ActionSubmitSwitchingOperationScreen"));
//const GalleryServiceOperationScreen = lazy(() => import( "../../screens/137/main/applay/action/ActionGalleryServiceOperationScreen"));
//const GalleryServiceScreen = lazy(() => import( "../../screens/137/main/applay/action/ActionGalleryServiceScreen"));
//const ShahrbanSatiaScreen = lazy(() => import( "../../screens/common/contactUs/ShahrbanSatiaScreen"));
//const DetailsGalleryServiceScreen = lazy(() => import( "../../screens/137/main/applay/DetailsGalleryServiceScreen"));
//const DetailsGalleryServiceOperationScreen = lazy(() => import( "../../screens/137/main/applay/DetailsGalleryServiceOperationScreen"));
//const ChatMessageScreen = lazy(() => import( "../../screens/common/chat/ChatMessageScreen"));
//const ListMessageChatScreen = lazy(() => import( "../../screens/common/chat/action/ActionListMessageChatScreen"));
//const ListUserChatScreen = lazy(() => import( "../../screens/common/chat/action/ActionListUserChatScreen"));
//const AboutUsScreen = lazy(() => import( "../../screens/common/contactUs/AboutUsScreen"));
//const PrivacyScreen = lazy(() => import( "../../screens/common/contactUs/PrivacyScreen"));
//const ListReport15RequestScreen = lazy(() => import( "../../screens/137/main/reports/action/ActionListReport15RequestScreen"));
//const ListReportStatusRequestScreen = lazy(() => import( "../../screens/137/main/reports/action/ActionListReportStatusRequestScreen"));
//const DetailsListTaskReportScreen = lazy(() => import( "../../screens/137/main/reports/DetailsListTaskReportScreen"));
//const ListReportTaskRequestScreen = lazy(() => import( "../../screens/137/main/reports/action/ActionListReportTaskRequestScreen"));
//const SubmitSendOperationScreen = lazy(() => import( "../../screens/137/main/applay/submitSend/action/ActionSubmitSendOperationScreen"));
//const MediaRecorderCapture = lazy(() => import( "../../customviews/record/video/MediaRecorderCapture"));
//const AClass = lazy(() => import( "../../screens/test/AClass"));
//const BClass = lazy(() => import( "../../screens/test/BClass"));
//const ExpertRegistrationMahaleMaScreen = lazy(() => import( "../../screens/137/main/reports/mahaleMa/action/ActionExpertRegistrationMahaleMaScreen"));
//const ListReportMahalehMaScreen = lazy(() => import( "../../screens/137/main/reports/mahaleMa/action/ActionListReportMahalehMaScreen"));
//const ListReportExitEnterMahalehMaScreen = lazy(() => import( "../../screens/137/main/reports/mahaleMa/action/ActionListReportExitEnterMahalehMaScreen"));
//const SettingMyStateScreen = lazy(() => import( "../../screens/137/main/myState/setting/SettingMyStateScreen"));
//const AddPatternMyStateScreen = lazy(() => import( "../../screens/137/main/myState/setting/AddPatternMyStateScreen"));
//const AccessReportMyStateScreen = lazy(() => import( "../../screens/137/main/myState/setting/AccessReportMyStateScreen"));
//const SettingReportMyStateScreen = lazy(() => import( "../../screens/137/main/myState/setting/SettingReportMyStateScreen"));
//const EditPatternShowMyStateScreen = lazy(() => import( "../../screens/137/main/myState/setting/EditPatternShowMyStateScreen"));
//const DashboardMyStateScreen = lazy(() => import( "../../screens/137/main/myState/setting/DashboardMyStateScreen"));
//const SecondScreen = lazy(() => import( "../../web/screens/SecondScreen"));
//const HomeScreen = lazy(() => import( "../../web/screens/HomeScreen"));

const SplashScreen = getNameComponent('SplashScreen');
const MainScreen = getNameComponent('MainScreen');
const ListNewsScreen = getNameComponent('ListNewsScreen');
const EnterCodeScreen = getNameComponent('EnterCodeScreen');
const InformationScreen = getNameComponent('InformationScreen');
const LoginEnterPhoneScreen = getNameComponent('LoginEnterPhoneScreen');
const LoginScreen = getNameComponent('LoginScreen');
const LoginEnterPhoneCodeScreen = getNameComponent('LoginEnterPhoneCodeScreen');
const MenuDrawer = getNameComponent('MenuDrawer');
const SatiaScreen = getNameComponent('SatiaScreen');
const ShowMap = getNameComponent('ShowMap');
const WebViewScreen = getNameComponent('WebViewScreen');
const ApplyScreen = getNameComponent('ApplyScreen');
const DetailsScreen = getNameComponent('DetailsScreen');
const CategoryScreen = getNameComponent('CategoryScreen');
const AdvancedSearchScreen = getNameComponent('AdvancedSearchScreen');
const DetailsDeadScreen = getNameComponent('DetailsDeadScreen');
const ListDeadScreen = getNameComponent('ListDeadScreen');
const ListMyApplyScreen = getNameComponent('ListMyApplyScreen');
const ListMyRegisterComplaintsScreen = getNameComponent('ListMyRegisterComplaintsScreen');
const SubmitRequestScreen22 = getNameComponent('SubmitRequestScreen22');
const DetailsRequestScreen = getNameComponent('DetailsRequestScreen');
const ProfileScreen = getNameComponent('ProfileScreen');
const RegisterComplaintsScreen = getNameComponent('RegisterComplaintsScreen');
const DetailsRegisterComplaintsScreen = getNameComponent('DetailsRegisterComplaintsScreen');
const ChangePassScreen = getNameComponent('ChangePassScreen');
const ChangeInformationScreen = getNameComponent('ChangeInformationScreen');
const ListMyApplyOperationScreen = getNameComponent('ListMyApplyOperationScreen');
const ListOperatorApplyScreen = getNameComponent('ListOperatorApplyScreen');
const DetailsOperatorApplyScreen = getNameComponent('DetailsOperatorApplyScreen');
const SubmitSwitchingOperationScreen = getNameComponent('SubmitSwitchingOperationScreen');
const GalleryServiceOperationScreen = getNameComponent('GalleryServiceOperationScreen');
const GalleryServiceScreen = getNameComponent('GalleryServiceScreen');
const ShahrbanSatiaScreen = getNameComponent('ShahrbanSatiaScreen');
const DetailsGalleryServiceScreen = getNameComponent('DetailsGalleryServiceScreen');
const DetailsGalleryServiceOperationScreen = getNameComponent('DetailsGalleryServiceOperationScreen');
const ChatMessageScreen = getNameComponent('ChatMessageScreen');
const ListMessageChatScreen = getNameComponent('ListMessageChatScreen');
const ListUserChatScreen = getNameComponent('ListUserChatScreen');
const AboutUsScreen = getNameComponent('AboutUsScreen');
const PrivacyScreen = getNameComponent('PrivacyScreen');
const ListReportArrearsScreen = getNameComponent('ListReportArrearsScreen');
const ListReport15RequestScreen = getNameComponent('ListReport15RequestScreen');
const ListReport15RequestScreen2 = getNameComponent('ListReport15RequestScreen2');
const ListReportStatusRequestScreen = getNameComponent('ListReportStatusRequestScreen');
const ListReportStatusRequestScreen2 = getNameComponent('ListReportStatusRequestScreen2');
const DetailsListTaskReportScreen = getNameComponent('DetailsListTaskReportScreen');
const ListReportTaskRequestScreen = getNameComponent('ListReportTaskRequestScreen');
const SubmitSendOperationScreen = getNameComponent('SubmitSendOperationScreen');
const MediaRecorderCapture = getNameComponent('MediaRecorderCapture');
const AClass = getNameComponent('AClass');
const BClass = getNameComponent('BClass');
const ExpertRegistrationMahaleMaScreen = getNameComponent('ExpertRegistrationMahaleMaScreen');
const ListReportMahalehMaScreen = getNameComponent('ListReportMahalehMaScreen');
const ListReportExitEnterMahalehMaScreen = getNameComponent('ListReportExitEnterMahalehMaScreen');
const SettingMyStateScreen = getNameComponent('SettingMyStateScreen');
const AddPatternMyStateScreen = getNameComponent('AddPatternMyStateScreen');
const AccessReportMyStateScreen = getNameComponent('AccessReportMyStateScreen');
const SettingReportMyStateScreen = getNameComponent('SettingReportMyStateScreen');
const EditPatternShowMyStateScreen = getNameComponent('EditPatternShowMyStateScreen');
const UnitsMyStateScreen = getNameComponent('UnitsMyStateScreen');
const DashboardMyStateScreen = getNameComponent('DashboardMyStateScreen');
const SecondScreen = getNameComponent('SecondScreen');
const HomeScreen = getNameComponent('HomeScreen');
const ListCityScreen = getNameComponent('ListCityScreen');
const ApplyParentScreen = getNameComponent('ApplyParentScreen');
//const PermissionsPage = getNameComponent('PermissionsPage');
//const CameraPage = getNameComponent('CameraPage');
//const MediaPage = getNameComponent('MediaPage');
const CameraTestRecord = getNameComponent('CameraTestRecord');
//const ChartMyStateScreen = getNameComponent("ChartMyStateScreen");
// const {
//     serviceActionSetConnectionType,
//     serviceActionSetToken, serviceActionSetUser,
//     serviceActionTokenFirebase,
// } = SplashScreen;

import i18n from '../../I18n/i18n';
import HMLoading from '../../customviews/HMLoading';
import {
    serviceActionSetConnectionType,
    serviceActionSetIsConnected, serviceActionSetToken, serviceActionSetUser,
    serviceActionTokenFirebase,
} from '../../screens/137/splash/action/ActionSplashGetAllData';
// import {PermissionsPage} from '../../screens/common/camera/PermissionsPage';
// import {CameraPage} from '../../screens/common/camera/CameraPage';

// import ApplyParentScreen from "../../screens/137/main/applay/ApplyParentScreen";


function getNameComponent(type) {
    return possiblePaths[type];
}

function lazyComponent(type) {
    //getNameComponent()
    // switch (type) {
    //
    //     case "MainScreen":
    //         return Platform.OS === "web" ? lazy(() => import("../../screens/137/main/MainScreen")) : require("../../screens/137/main/MainScreen").default;
    //
    //     case "ListNewsScreen":
    //         return Platform.OS === "web" ? lazy(() => import("../../screens/137/main/MainScreen")) : require("../../screens/137/main/MainScreen").default;
    //
    // }
}

enableScreens();

function lazyLoadImport() {
    if (Platform.OS === 'web') {
        return '';
    } else {
        return null;
    }
}

const theme = {
    ...DarkTheme,
    // ...PaperDarkTheme,
    colors: {
        ...DarkTheme.colors,
        // ...PaperDarkTheme.colors,
        background: '#f0f0f0',
        text: '#ffffff',
    },
};


const HomeStack = createStackNavigator();

function HomeStackScreen() {

    return (
        <HomeStack.Navigator
            initialRouteName="MainScreen"
            screenOptions={{
                headerTitleAlign: 'center',
                headerStyle: {
                    backgroundColor: '#621FF7',
                },
                headerTintColor: '#fff',
                headerTitleStyle: {
                    fontWeight: 'bold',
                },
                headerShown: false,

            }}
        >
            <HomeStack.Screen name="MainScreen" component={MainScreen}/>
            <HomeStack.Screen name="SatiaScreen" component={SatiaScreen}/>
            <HomeStack.Screen name="ShowMap" component={ShowMap}/>
            <HomeStack.Screen name="WebViewScreen" component={WebViewScreen}/>
            <HomeStack.Screen name="ListNewsScreen" component={ListNewsScreen}/>
            <HomeStack.Screen name="ApplyScreen" component={ApplyScreen}/>
            <HomeStack.Screen name="ApplyParentScreen" component={ApplyParentScreen}/>
            <HomeStack.Screen name="DetailsScreen" component={DetailsScreen}/>
            <HomeStack.Screen name="CategoryScreen" component={CategoryScreen}/>
            <HomeStack.Screen name="AdvancedSearchScreen" component={AdvancedSearchScreen}/>
            <HomeStack.Screen name="DetailsDeadScreen" component={DetailsDeadScreen}/>
            <HomeStack.Screen name="ListDeadScreen" component={ListDeadScreen}/>
            <HomeStack.Screen name="ListMyApplyScreen" component={ListMyApplyScreen}/>
            <HomeStack.Screen name="ListMyRegisterComplaintsScreen" component={ListMyRegisterComplaintsScreen}/>
            <HomeStack.Screen name="SubmitRequestScreen" component={SubmitRequestScreen22}/>
            <HomeStack.Screen name="DetailsRequestScreen" component={DetailsRequestScreen}/>
            <HomeStack.Screen name="ProfileScreen" component={ProfileScreen}/>
            <HomeStack.Screen name="RegisterComplaintsScreen" component={RegisterComplaintsScreen}/>
            <HomeStack.Screen name="DetailsRegisterComplaintsScreen" component={DetailsRegisterComplaintsScreen}/>
            <HomeStack.Screen name="ChangePassScreen" component={ChangePassScreen}/>
            <HomeStack.Screen name="ChangeInformationScreen" component={ChangeInformationScreen}/>
            <HomeStack.Screen name="GalleryServiceScreen" component={GalleryServiceScreen}/>
            <HomeStack.Screen name="ShahrbanSatiaScreen" component={ShahrbanSatiaScreen}/>
            {/*<HomeStack.Screen name="LoginStackScreen" component={LoginStackScreen}/>*/}
            {/*  <HomeStack.Screen name="LoginEnterPhoneCodeScreen"
                               component={LoginEnterPhoneCodeScreen}/>
            <HomeStack.Screen name="EnterCodeScreen"
                               component={EnterCodeScreen}/>
            <HomeStack.Screen name="InformationScreen"
                               component={InformationScreen}/>
            <HomeStack.Screen name="LoginEnterPhoneScreen"
                               component={LoginEnterPhoneScreen}/>
            <HomeStack.Screen name="LoginScreen"
                               component={LoginScreen}/>*/}
            <HomeStack.Screen name="ListMyApplyOperationScreen" component={ListMyApplyOperationScreen}/>
            <HomeStack.Screen name="ListOperatorApplyScreen" component={ListOperatorApplyScreen}/>

            <HomeStack.Screen name="DetailsOperatorApplyScreen" component={DetailsOperatorApplyScreen}/>
            <HomeStack.Screen name="SubmitSwitchingOperationScreen" component={SubmitSwitchingOperationScreen}/>
            <HomeStack.Screen name="GalleryServiceOperationScreen" component={GalleryServiceOperationScreen}/>
            <HomeStack.Screen name="ListUserChatScreen" component={ListUserChatScreen}/>
            <HomeStack.Screen name="ListMessageChatScreen" component={ListMessageChatScreen}/>
            <HomeStack.Screen name="AboutUsScreen" component={AboutUsScreen}/>
            <HomeStack.Screen name="ListReportArrearsScreen" component={ListReportArrearsScreen}/>
            <HomeStack.Screen name="ListReport15RequestScreen" component={ListReport15RequestScreen}/>
            <HomeStack.Screen name="ListReport15RequestScreen2" component={ListReport15RequestScreen2}/>
            <HomeStack.Screen name="ListReportStatusRequestScreen" component={ListReportStatusRequestScreen}/>
            <HomeStack.Screen name="ListReportStatusRequestScreen2" component={ListReportStatusRequestScreen2}/>

            <HomeStack.Screen name="DetailsListTaskReportScreen" component={DetailsListTaskReportScreen}/>
            <HomeStack.Screen name="ListReportTaskRequestScreen" component={ListReportTaskRequestScreen}/>
            <HomeStack.Screen name="SubmitSendOperationScreen" component={SubmitSendOperationScreen}/>

            <HomeStack.Screen name="MediaRecorderCapture" component={MediaRecorderCapture}/>

            {/*Mahale*/}
            <HomeStack.Screen name="ExpertRegistrationMahaleMaScreen" component={ExpertRegistrationMahaleMaScreen}/>
            <HomeStack.Screen name="ListReportMahalehMaScreen" component={ListReportMahalehMaScreen}/>
            <HomeStack.Screen name="ListReportExitEnterMahalehMaScreen" component={ListReportExitEnterMahalehMaScreen}/>


            {/*MyState*/}
            <HomeStack.Screen name="SettingMyStateScreen" component={SettingMyStateScreen}/>
            <HomeStack.Screen name="AddPatternMyStateScreen" component={AddPatternMyStateScreen}/>
            <HomeStack.Screen name="AccessReportMyStateScreen" component={AccessReportMyStateScreen}/>
            <HomeStack.Screen name="SettingReportMyStateScreen" component={SettingReportMyStateScreen}/>
            <HomeStack.Screen name="EditPatternShowMyStateScreen" component={EditPatternShowMyStateScreen}/>
            <HomeStack.Screen name="UnitsMyStateScreen" component={UnitsMyStateScreen}/>
            <HomeStack.Screen name="DashboardMyStateScreen" component={DashboardMyStateScreen}/>

            <HomeStack.Screen name="ListCityScreen" component={ListCityScreen}/>
            {/*<HomeStack.Screen name="ApplyParentScreen" component={ApplyParentScreen}/>*/}


            {/*{Platform.OS==="web"?null: <HomeStack.Screen name="PermissionsPage" component={PermissionsPage}/>}*/}
            {/*{Platform.OS==="web"?null: <HomeStack.Screen name="CameraPage" component={CameraPage}/>}*/}
            {/*{Platform.OS==="web"?null: <HomeStack.Screen name="MediaPage" component={MediaPage}/>}*/}
            {Platform.OS==="web"?null: <HomeStack.Screen name="CameraTestRecord" component={CameraTestRecord}/>}

        </HomeStack.Navigator>
    );
};

const LoginStack = createStackNavigator();

function LoginStackScreen() {

    return (
        <LoginStack.Navigator
            initialRouteName="LoginEnterPhoneScreen"
            screenOptions={{
                headerTitleAlign: 'center',
                headerStyle: {
                    backgroundColor: '#621FF7',
                },
                headerTintColor: '#fff',
                headerTitleStyle: {
                    fontWeight: 'bold',
                },
                headerShown: false,
            }}

        >
            <LoginStack.Screen name="LoginEnterPhoneCodeScreen"
                               component={LoginEnterPhoneCodeScreen}/>
            <LoginStack.Screen name="EnterCodeScreen"
                               component={EnterCodeScreen}/>
            <LoginStack.Screen name="InformationScreen"
                               component={InformationScreen}/>
            <LoginStack.Screen name="LoginEnterPhoneScreen"
                               component={LoginEnterPhoneScreen}/>
            <LoginStack.Screen name="LoginScreen"
                               component={LoginScreen}/>
            <LoginStack.Screen name="ChangePassScreen" component={ChangePassScreen}/>
            <LoginStack.Screen name="ListCityScreen" component={ListCityScreen}/>

            {/*
            <HomeStack.Screen name="SecondScreen" component={SecondScreen}/>
*/}

        </LoginStack.Navigator>
    );
};


const linking = {
    prefixes: [
        'https://app.example.com',
        /* your linking prefixes */
    ],
    config: {
        screens: {
            initialRouteName: 'ListCityScreen',

            SplashScreen: {
                path: 'splash/:routeName',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },

            ListAccountSatiaScreen: 'accounts',
            DetailsGalleryServiceScreen_Root: {
                path: 'details_gallery/:id',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            DetailsGalleryServiceOperationScreen_Root: {
                path: 'details_gallery_operation/:id',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            ChatScreen_Root: {
                path: 'chat',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            GalleryServiceOperationScreen_Root: {
                path: 'list_gallery_operation',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            GalleryServiceScreen_Root: {
                path: 'list_gallery',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            DetailsOperatorApplyScreen_Root: {
                path: 'details_request_operation',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            // ListCityScreen: {
            //     path: 'ListCity',
            //     // parse: {
            //     //     id: (id) => `user-${id}`,
            //     // },
            //     // stringify: {
            //     //     id: (id) => id.replace(/^user-/, ''),
            //     // },
            // },
            // DrawerScreen: {
            //
            //     path: 'drawer',
            //     screens: {
            //         HomeStackScreen: {
            //
            //             path: 'home',
            //             /*   screens: {
            //                    MainSatiaScreen: 'main',
            //
            //                }*/
            //
            //         }
            //
            //     }
            //
            // }


        },

    },

};
/*const linking1 = {
    prefixes: [
        'https://app.example.com'
        /!* your linking prefixes *!/
    ],
    config: {
        screens: {
            initialRouteName: 'SplashScreen',

            SplashScreen: 'splash',
            DrawerScreen: {
//drawer
                path: 'drawer',
                screens: {
                    LoginStackScreen: {
                        //drawer/login_Stack
                        path: 'login_Stack',
                        screens: {
                            //drawer/login_Stack/login

                            LoginEnterPhoneCodeScreen: {
                                path: 'loginCode',
                            },
                            EnterCodeScreen: {
                                path: 'code',
                            },
                            InformationScreen: {
                                path: 'information',
                            },
                            LoginEnterPhoneScreen: {
                                path: 'loginUsername',
                            },

                            LoginScreen: {
                                path: 'login',
                            },

                            ChangePassScreen: {
                                path: 'changePass',
                            },


                        }

                    },
                    HomeStackScreen: {
                        //drawer/home_Stack
                        path: "home_stack",
                        screens: {
                            MainScreen: {
                                path: 'main',

                            },
                            ListNewsScreen: {
                                path: 'news',

                            },
                            CategoryScreen: {
                                path: 'category',


                            },
                            ApplyScreen: {
                                path: 'apply',

                            },
                            DetailsScreen: {
                                path: 'details',

                            },
                            WebViewScreen: {
                                path: 'page',

                            },
                            SubmitRequestScreen: {
                                path: 'submitRequest',

                            },
                            ListMyApplyScreen: {
                                path: 'listMyApply',

                            },
                            DetailsRequestScreen: {
                                //drawer/home_Stack
                                path: 'detailsRequest',


                            },
                        },

                    },

                }

            },
            AStackScreen: {
//rout/login
                path: 'test',
                screens: {
                    // AClass: 'a',
                    // exact: true,

                    AClass: {
                        //drawer/login_Stack
                        path: 'a',


                    },
                    BClass: {
                        //drawer/login_Stack
                        path: 'b',


                    },
                }

            },
            LoginStack: {
//rout/login
                path: 'rout',
                screens: {
                    LoginEnterPhoneCodeScreen: 'login',
                    exact: true,

                }

            },
            /!*     DrawerScreen: {
     //drawer
                     path: 'drawer',
                     screens: {
                         LoginStackScreen: {
                             //drawer/login_Stack
                             path: 'login_Stack',
                             screens: {
                                 //drawer/login_Stack/login
                                 LoginEnterPhoneCodeScreen: 'login',
                                 exact: true,

                             }

                         },
                         HomeStackScreen: {
                             //drawer/home_Stack
                             path: 'home_Stack',
                             screens: {
                                 //drawer/home_Stack/shahrbanSatia

                                 ShahrbanSatiaScreen: 'shahrbanSatia',
                                 exact: true,

                             }

                         },

                     }

                 },*!/
            ListAccountSatiaScreen: 'accounts',
            DetailsGalleryServiceScreen_Root: {
                path: 'details_gallery/:id',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            DetailsGalleryServiceOperationScreen_Root: {
                path: 'details_gallery_operation/:id',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            ChatScreen_Root: {
                path: 'chat',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            GalleryServiceOperationScreen_Root: {
                path: 'list_gallery_operation',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            GalleryServiceScreen_Root: {
                path: 'list_gallery',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            DetailsOperatorApplyScreen_Root: {
                path: 'details_request_operation',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            ListCityScreen: {
                path: 'ListCity',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            // DrawerScreen: {
            //
            //     path: 'drawer',
            //     screens: {
            //         HomeStackScreen: {
            //
            //             path: 'home',
            //             /!*   screens: {
            //                    MainSatiaScreen: 'main',
            //
            //                }*!/
            //
            //         }
            //
            //     }
            //
            // }


        }

    },

};
const OperationStack = createStackNavigator();*/
/*

function OperationStackScreen() {

    return (
        <OperationStack.Navigator
            initialRouteName="ApplyScreen"
            screenOptions={{
                headerTitleAlign: 'center',
                headerStyle: {
                    backgroundColor: '#621FF7',
                },
                headerTintColor: '#fff',
                headerTitleStyle: {
                    fontWeight: 'bold',
                },
                headerShown: false

            }}
        >
            <OperationStack.Screen name="ApplyScreen" component={ApplyScreen}/>
            <OperationStack.Screen name="ListMyApplyOperationScreen" component={ListMyApplyOperationScreen}/>
            <OperationStack.Screen name="ListOperatorApplyScreen" component={ListOperatorApplyScreen}/>

            <OperationStack.Screen name="MainScreen" component={MainScreen}/>
            <OperationStack.Screen name="SatiaScreen" component={SatiaScreen}/>
            <OperationStack.Screen name="ShowMap" component={ShowMap}/>
            <OperationStack.Screen name="WebViewScreen" component={WebViewScreen}/>
            <OperationStack.Screen name="ListNewsScreen" component={ListNewsScreen}/>
            <OperationStack.Screen name="DetailsScreen" component={DetailsScreen}/>
            <OperationStack.Screen name="CategoryScreen" component={CategoryScreen}/>
            <OperationStack.Screen name="AdvancedSearchScreen" component={AdvancedSearchScreen}/>
            <OperationStack.Screen name="DetailsDeadScreen" component={DetailsDeadScreen}/>
            <OperationStack.Screen name="ListDeadScreen" component={ListDeadScreen}/>
            <OperationStack.Screen name="ListMyApplyScreen" component={ListMyApplyScreen}/>
            <OperationStack.Screen name="ListMyRegisterComplaintsScreen" component={ListMyRegisterComplaintsScreen}/>
            <OperationStack.Screen name="SubmitRequestScreen" component={SubmitRequestScreen22}/>
            <OperationStack.Screen name="DetailsRequestScreen" component={DetailsRequestScreen}/>
            <OperationStack.Screen name="ProfileScreen" component={ProfileScreen}/>
            <OperationStack.Screen name="RegisterComplaintsScreen" component={RegisterComplaintsScreen}/>
            <OperationStack.Screen name="DetailsRegisterComplaintsScreen" component={DetailsRegisterComplaintsScreen}/>
            <OperationStack.Screen name="ChangePassScreen" component={ChangePassScreen}/>
            <OperationStack.Screen name="ChangeInformationScreen" component={ChangeInformationScreen}/>
            <OperationStack.Screen name="DetailsOperatorApplyScreen" component={DetailsOperatorApplyScreen}/>
            <OperationStack.Screen name="SubmitSwitchingOperationScreen" component={SubmitSwitchingOperationScreen}/>
            <OperationStack.Screen name="GalleryServiceOperationScreen" component={GalleryServiceOperationScreen}/>
            <OperationStack.Screen name="ListUserChatScreen" component={ListUserChatScreen}/>
            <OperationStack.Screen name="ListMessageChatScreen" component={ListMessageChatScreen}/>
            <OperationStack.Screen name="AboutUsScreen" component={AboutUsScreen}/>
            <OperationStack.Screen name="ListReport15RequestScreen" component={ListReport15RequestScreen}/>
            <OperationStack.Screen name="ListReportStatusRequestScreen" component={ListReportStatusRequestScreen}/>
            <OperationStack.Screen name="DetailsListTaskReportScreen" component={DetailsListTaskReportScreen}/>
            <OperationStack.Screen name="ListReportTaskRequestScreen" component={ListReportTaskRequestScreen}/>
        </OperationStack.Navigator>
    );
};
*/


const Drawer = createDrawerNavigator();
const DrawerScreen = () => (
    <Drawer.Navigator
        initialRouteName="HomeStackScreen"
        screenOptions={{

            headerShown: false,
            //drawerPosition: 'left',
        }}
        // drawerType="back"
        drawerPosition={I18nManager.getConstants().isRTL ? 'right' : 'left'}
        drawerContent={props => <MenuDrawer {...props}

        />}>


        {/*<Drawer.Screen name="MainSatiaScreen" component={MainSatiaScreen}/>*/}
        <DrawerOperation.Screen name="HomeStackScreen" component={HomeStackScreen}/>
        <DrawerOperation.Screen name="LoginStackScreen" component={LoginStackScreen}/>

        {/*    <Drawer.Screen name="HomeDrawer" component={HomeScreen}/>
        <Drawer.Screen name="SupportScreen" component={SecondScreen}/>*/}
        {/*<Drawer.Screen name="UserScreen" component={UserScreen}/>*/}
        {/*<Drawer.Screen name="HomeScreen" component={HomeScreen}/>*/}
    </Drawer.Navigator>
);
const DrawerOperation = createDrawerNavigator();
/*const DrawerOperationScreen = () => (
    <DrawerOperation.Navigator
        initialRouteName="HomeStackScreen"
        screenOptions={{

            headerShown: false
        }}

        drawerContent={props => <MenuDrawer {...props}

        />}>


        {/!*<Drawer.Screen name="MainSatiaScreen" component={MainSatiaScreen}/>*!/}

        <Drawer.Screen name="OperationStackScreen" component={OperationStackScreen}/>


        {/!*    <Drawer.Screen name="HomeDrawer" component={HomeScreen}/>
        <Drawer.Screen name="SupportScreen" component={SecondScreen}/>*!/}
        {/!*<Drawer.Screen name="UserScreen" component={UserScreen}/>*!/}
        {/!*<Drawer.Screen name="HomeScreen" component={HomeScreen}/>*!/}
    </DrawerOperation.Navigator>
);*/
const RootStack = createStackNavigator();
const Tab = createBottomTabNavigator();

function Home() {
    return (
        <Tab.Navigator>

            <Tab.Screen name="Profile" component={HomeScreen}/>
            <Tab.Screen name="Feed" component={SecondScreen}/>
        </Tab.Navigator>
    );
}

let token = null;
let container = null;

/*const storage = Platform.select({
    web: () => require("localforage"),
    android: () => require("@react-native-community/async-storage").default,
    ios: () => require("@react-native-community/async-storage").default
})();*/
class Router137 extends PureComponent {
    constructor(props) {
        super(props);
        container = this;
        this.state = {

            modalHeight: 0,
            oneDoLocation: true,


            RequestSubmitPending: false,

        };
        /*     Tools.getCurrentPosition(
                 "ShowMap",
                 null,
                 null,
                 this.goScreen,
                 this.stateError,
                 "Parent"`1`
             );*/
        global.MyVar = 'https://aboutreact.com';
    }


    async componentWillMount() {

        token = await AsyngStorageClass.checkToken();
        if (token) {
            store.dispatch(serviceActionSetToken(token));

            let user = await AsyngStorageClass.getASyng(typeExport._USER);
            store.dispatch(serviceActionSetUser(user));

            /*    let account = await AsyngStorageClass.getASyng("Account");
                store.dispatch(serviceActionAccount(account, 0));*/
        }


        let token_fb = await AsyncStorage.getItem('fcmToken');

        store.dispatch(serviceActionTokenFirebase(token_fb));


    }

    componentWillReceiveProps(props) {

    }

    async componentDidMount() {


        // golbal._weatherCity
        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2);

        // this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', this._keyboardDidShow);
        // this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', this._keyboardDidHide);
        // container.toast.setKeyboardHeight(0)
        let Conn = false;

        const dispatchConnected = state => {

            let isConnected = state.isConnected;
            this.props.setIsConnected(isConnected);
            store.dispatch(serviceActionSetConnectionType(state));

            /*   if (Platform.OS === "android")
                   this.checkSatusWifi()*/
            Conn = isConnected;
            if (isConnected && this.state.oneDoLocation) {

                this.setState({
                        oneDoLocation: false,
                    },
                    () => {

                        // Tools.checkPermission(
                        //     "ShowMap",
                        //     null,
                        //     null,
                        //     this.goScreen,
                        //     this.stateError,
                        //     "Parent"
                        // );
                    },
                );

            }


            if (isConnected && !checkLogin && !this.state.RequestSubmitPending) {
                this.setState({
                        RequestSubmitPending: true,
                    },
                    () => {
                        Tools.RequestSubmit('POST', typeExport._baseUrlSaina, null, 5, () => {
                            container.setState({
                                RequestSubmitPending: false,
                            });
                        });
                    });
            }
        };


        NetInfo.addEventListener(dispatchConnected);

        /*    if (Platform.OS !== 'ios'
            )
            {
                Tools.checkPermission(
                    "ShowMap",
                    null,
                    null,
                    this.goScreen,
                    this.stateError,
                    "Parent"
                );
            }*/

        // if (Platform.OS !== 'ios' && !checkLogin)
        //     Tools.RequestSubmit("POST", typeExport._baseUrlSaina, null, 5)
    }

/////////////////////////////////////////


    goScreen(position) {
        container.setState({oneDoLocation: true});
        //   store.dispatch(serviceActionSetLocation(position))
        //NavigationService.navigateParams("SelectMap", {item: position})
    }

    stateError() {
        container.setState({
            oneDoLocation: true,
            //    locationEnabled: false,
            //  isLoading: false,
        }, () => {
        });
    }

    checkSatusWifi() {
        wifi.isEnabled((isEnabled) => {
            store.dispatch(serviceActionSetwifiIsEnabled(isEnabled));


            wifi.connectionStatus((isConnected) => {
                store.dispatch(serviceActionSetwifiConnectionStatus(isConnected));

            });

        });

    }

    render() {
        let City = this.props.DataSplashScreen?.City;
        return (


            //  <View style={[{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0}]}>
            <Suspense fallback={<HMLoading/>}>
                <NavigationContainer ref={navigationRef} theme={theme} linking={linking}
                                     documentTitle={{
                                         formatter: (options, route) =>
                                             //     `${options?.title ?? route?.name} - My Cool App`,
                                             //  `${(typeExport._NameApp === "Cloud"|| typeExport._NameApp === "CloudTest") && Tools.CheckValue(City) ? City.name +" من" : i18n.t('appName')}`,
                                             `${ i18n.t('appName')}`,
                                     }}

                >
                    <RootStack.Navigator headerMode="none" initialRouteName="SplashScreen">

                        {/*
                    <RootStack.Screen name="AnimationTest" component={AnimationTest}/>
*/}

                        {/*       {
                        (this.props.TypeLogin === 2 ? !this.props.resultsShahrdar : !this.props.results) ?

                            (!this.props.token && this.props.TypeLogin === 2 ?
                                <RootStack.Screen name="LoginStack" component={LoginStackScreen}/>
                                :
                                <RootStack.Screen name="SplashScreen" component={SplashScreen}/>)
                            :
                            (this.props.TypeLogin === 2 ?
                                    <RootStack.Screen options={{headerShown: false}} name="OperationStack"
                                                      component={DrawerOperationScreen}/>
                                    :
                                    <RootStack.Screen options={{headerShown: false}} name="DrawerScreen"
                                                      component={DrawerScreen}/>
                            )
                    }*/}
                        {/*<RootStack.Screen name="AnimationTest" component={AnimationTest}/>*/}

                        {/*<RootStack.Screen name="ChartMyStateScreen" component={ChartMyStateScreen}/>*/}
                        <RootStack.Screen name="SplashScreen" component={SplashScreen}/>
                        {/*<RootStack.Screen name="ListCityScreen" component={ListCityScreen}/>*/}

                        <RootStack.Screen options={{headerShown: false}} name="DrawerScreen"
                                          component={DrawerScreen}/>
                        {/*<RootStack.Screen name="LoginStackScreen" component={LoginStackScreen}/>*/}

                        {/*<RootStack.Screen name="AStackScreen" component={AStackScreen}/>*/}

                        {
                            // (!this.props.results) ?
                            //
                            //     <RootStack.Screen name="SplashScreen" component={SplashScreen}/>
                            //     :
                            //     <RootStack.Screen options={{headerShown: false}} name="DrawerScreen"
                            //                       component={DrawerScreen}/>

                        }


                        <RootStack.Screen name="DetailsGalleryServiceScreen_Root"
                                          component={DetailsGalleryServiceScreen}/>
                        <RootStack.Screen name="DetailsGalleryServiceOperationScreen_Root"
                                          component={DetailsGalleryServiceOperationScreen}/>
                        <RootStack.Screen name="ChatScreen_Root" component={ChatMessageScreen}/>
                        <RootStack.Screen name="GalleryServiceOperationScreen_Root"
                                          component={GalleryServiceOperationScreen}/>
                        <RootStack.Screen name="GalleryServiceScreen_Root" component={GalleryServiceScreen}/>
                        <RootStack.Screen name="DetailsOperatorApplyScreen_Root"
                                          component={DetailsOperatorApplyScreen}/>
                        <RootStack.Screen name="ListUserChatScreen_Root" component={ListUserChatScreen}/>
                        <RootStack.Screen name="ListMessageChatScreen_Root" component={ListMessageChatScreen}/>
                        <RootStack.Screen name="PrivacyScreen" component={PrivacyScreen}/>
                        {/*   <RootStack.Screen name="LoginStack" component={LoginStackScreen}/>
                    <RootStack.Screen options={{headerShown: false}} name="DrawerScreen"
                                      component={DrawerScreen}/>*/}
                    </RootStack.Navigator>

                </NavigationContainer>
            </Suspense>
            // </View>

        );
    }


}

const mapStateToProps = state => ({
    token: state.reducerSplashGetAllData.token,
    resultsShahrdar: state.reducerSplashGetAllData.resultsShahrdar,
    resultsSatia: state.reducerSplashGetAllData.resultsSatia,
    results: state.reducerSplashGetAllData.results,
    user: state.reducerSplashGetAllData.user,
    Account: state.reducerSplashGetAllData.Account,
    DataSplashScreen: state.reducerSplashGetAllData,
    TypeLogin: state.reducerSplashGetAllData.TypeLogin,
});
const mapDispatchToProps = dispatch => {
    return {
        setIsConnected: (data) => dispatch(serviceActionSetIsConnected(data)),

    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Router137);
